<app-loader *ngIf="isLoading"></app-loader>
<div class="container-fluid contentSize contentHeight">
    <h1 class="text-center containerTitle"> Historique des comptes clients </h1>
    <table class="table table-bordered table-hover bg-light">
      <caption></caption>
        <thead class="stickyheader">
            <tr>
                <th scope="col">Action</th>
                <th scope="col">Date</th>
                <th scope="col">Mail utilisateur</th>
                <th scope="col">Identité utilisateur</th>
                <th scope="col">Pays utilisateur</th>
                <th scope="col">Personne qui a activé</th>
                <th scope="col">Pays référent technique</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let hist of history">
                <td *ngIf="hist.action == 'accept'" class="text-success"> Demande acceptée </td>
                <td *ngIf="hist.action == 'refuse'" class="text-danger"> Demande refusée </td>
                <td *ngIf="hist.action == 'register'" class="text-primary"> Demande de compte </td>
                <td> {{hist.actionDate | date:'dd/MM/yyyy'}} </td>
                <td> {{hist.mail}} </td>
                <td> {{hist.firstname}} {{hist.name}} </td>
                <td> {{hist.country}} </td>
                <td  *ngIf="hist.rTname"> {{hist.rTname}} </td>
                <td *ngIf="!hist.rTname"> {{hist.ctcFirstname}} {{hist.ctcName}} </td>
                <td> {{hist.location}}</td>
            </tr>
        </tbody>
        <tfoot class="footer"> 
            <tr>
                <td class="footertd" colspan="10">
                    <mat-paginator [hidePageSize]="true" [length]="totalSize" [pageSize]="10"  (page)="handlePage($event)"></mat-paginator>
                </td>
            </tr>
        </tfoot>
    </table>
</div>
